import { z } from 'zod';

import { TalentSearchItemsSchema } from './talent-search-items';

export const TalentSearchDisplayFiltersCategorySchema = z.object({
  name: z.string(),
  title: z.string(),
  isOpen: z.boolean(),
  selectedCount: z.number(),
  items: TalentSearchItemsSchema,
});

export type TalentSearchDisplayFiltersCategory = z.infer<
  typeof TalentSearchDisplayFiltersCategorySchema
>;
